import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Documents from "./pages/Documents";
import DocumentDetail from "./pages/DocumentDetail";
import Upload from "./pages/Upload";
import ValidationRules from "./pages/ValidationRules";
import ParserTemplates from "./pages/ParserTemplates";
import Reports from "./pages/Reports";
import Issues from "./pages/Issues";
import Settings from "./pages/Settings";
import BatchReport from "./pages/BatchReport";
import DataMatching from "./pages/DataMatching";
import DataMassaging from "./pages/DataMassaging";
import DataPipelines from "./pages/DataPipelines";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="documents" element={<Documents />} />
            <Route path="documents/:id" element={<DocumentDetail />} />
            <Route path="upload" element={<Upload />} />
            <Route path="validation-rules" element={<ValidationRules />} />
            <Route path="parser-templates" element={<ParserTemplates />} />
            <Route path="reports" element={<Reports />} />
            <Route path="batch-reports/:id" element={<BatchReport />} />
            <Route path="issues" element={<Issues />} />
            <Route path="matching" element={<DataMatching />} />
            <Route path="massaging" element={<DataMassaging />} />
            <Route path="pipelines" element={<DataPipelines />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
